import { render } from "./ParceirosLista.vue?vue&type=template&id=236f666f"
import script from "./ParceirosLista.vue?vue&type=script&lang=js"
export * from "./ParceirosLista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__